import type { ResultCode } from "@adyen/adyen-web";

export const isFailedAdyenResult = (result: ResultCode) => {
    // Adyen's "Cancelled" covers both a shopper backing out and a merchant/fraud-side
    // cancellation, with nothing in resultCode to tell the two apart. Treat it as a failure
    // so the latter is never silently swallowed as a benign shopper cancel.
    const resultsToFail: ResultCode[] = ["Refused", "Error", "Cancelled"];
    return resultsToFail.includes(result);
};
